import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { CalendarEventOccurrenceObject } from '@libs/types/src/services/object-type/calendar/calendar-item.object';
import { PlannedWorkEventData, PlannedWorkWidgetRow } from './planned-work-widget.types';
import { SocialCalendarWorkTypeEnum } from '@libs/types/src/services/enum/calendar-event-type.enum';

@Injectable()
export class PlannedWorkWidgetStore extends ComponentStoreV2Factory {

    // public rows = computed<CalendarEventOccurrenceGridObject>(() => this.mapRows(
    //     this.data.filterCalendarItems() ?? [],
    // ));

    public readonly workerCount = computed(
        () => 0,//new Set(this.rows().map(row => row.worker.id)).size,
    );

    private mapRows(items: CalendarEventOccurrenceObject[]): PlannedWorkWidgetRow[] {
        const allowedEventTypes = new Set<string>(Object.values(SocialCalendarWorkTypeEnum));

        return items
            .filter(item => !item.hidden && allowedEventTypes.has(item.eventType))
            .flatMap(item => item.occurrenceFolders.flatMap(folder => item.occurrenceUsers.map(worker => ({
                id: `${item.id}:${new Date(item.dateFrom).getTime()}:${folder.id}:${worker.id}`,
                folderId: folder.id,
                serviceId: folder.serviceId,
                client: folder.person,
                dateFrom: item.dateFrom,
                worker,
                addressTo: folder.serviceAddress?.address ?? null,
                plannedActivity: item.offers
                    .map(offer => offer.offer?.name || offer.offer?.code)
                    .filter((value): value is string => Boolean(value))
                    .join(', '),
                note: this.readNote(item.eventData),
            }))))
            .sort((left, right) => new Date(left.dateFrom).getTime() - new Date(right.dateFrom).getTime());
    }

    private readNote(eventData: string): string | null {
        try {
            const parsed: unknown = JSON.parse(eventData);
            if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;

            const data = parsed as PlannedWorkEventData;
            const note = data.note ?? data.description;
            return typeof note === 'string' && note.trim() ? note : null;
        } catch {
            return null;
        }
    }
}
